import React, { useContext, useState, useEffect, useCallback } from 'react'
import { Col, Row } from 'react-bootstrap';
import {
    getAccountTypeNameFromId, getAccountTypeFromId,
    getUserBillByBillId
} from './UserBillService';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { useLocation } from 'react-router-dom';
import { TenantContext } from 'tenant/TenantContext';
import { SubmitButton } from 'uiwidgets/SubmitButton';
import { CancelButton } from 'uiwidgets/CancelButton';
import _ from "lodash";
import { useNavigate } from 'react-router-dom';
import { PaymentCartContext } from 'pages/payment-cart/PaymentCartContext';
import BillDetail from 'uiwidgets/bill/BillDetail';
import { useParams } from 'react-router-dom';
import { SecurityContext } from '../../security/SecurityContext';
import { extractError } from 'api/ErrorUtil';
import { FormField } from 'uiwidgets/FormField';


const UserBillDetailPage = () => {

    const location = useLocation();
    const [userBillsData, setUserBillsData] = useState({});
    const [errors, setErrors] = useState({});
    const { businessConfig } = useContext(TenantContext);
    const navigate = useNavigate();
    const { addToCart } = useContext(PaymentCartContext);
    const { billId } = useParams();
    const secCtx = useContext(SecurityContext);

    const fetchUserBill = useCallback(async () => {
        let userAccounts = [{}];
        try {
            let bill = await getUserBillByBillId(billId);
            //fetch bill by bill id
            let userAccounts = secCtx.accounts.filter(acc => acc.id === bill.accountId);
            setUserBillsData({
                bill: bill,
                accountTypes: businessConfig.accountTypes,
                account: userAccounts[0]
            });
        } catch (error) {
            let errs = extractError(error);
            setUserBillsData({
                bill: {},
                accountTypes: businessConfig.accountTypes,
                account: userAccounts[0]
            })
            console.log(errs)
            setErrors(errs);
        }

    });

    useEffect(() => {

        if (billId) {
            fetchUserBill(billId);
        } else {
            setUserBillsData(location.state.userBillsData);
            console.log(location.state.userBillsData);
        }
    }, [])

    const handleSubmit = async (event) => {
        let bill = userBillsData.bill;
        let recFreq = userBillsData.billPaymentFrequency;
        event.preventDefault();
        addToCart(bill.billId, 'BILL', { ...bill, frequency: recFreq }, userBillsData.account,
            getAccountTypeFromId(userBillsData.account.accountTypeId, userBillsData.accountTypes),
            1);
        navigate('/checkout-form');
    }

    const handleCancel = async (event) => {
        event.preventDefault();
        navigate(-1);
    }

    const handleChange = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setUserBillsData({
            ...userBillsData,
            [name]: value,
        })
    }

    return (
        <>
            {!_.isEmpty(userBillsData) &&
                <FormContainer submitButtonFunction={handleSubmit}>
                    <BillDetail businessConfig={businessConfig} bill={userBillsData.bill} account={userBillsData.account}
                        accountTypeName={getAccountTypeNameFromId(userBillsData.account.accountTypeId, userBillsData.accountTypes)} />
                    <Row><Col>&nbsp;</Col></Row>
                    <Row><Col>&nbsp;</Col></Row>

                    <Row><Col sm={12} md={4} lg={4}>
                    <FormField name="billPaymentFrequency" label="Select frequency to make payment recurring"
                        type="select" onChange={handleChange} value={userBillsData.billPaymentFrequency} valstate={true} valMsg="">
                        <option value="" key="NOVAL">Select Frequency to make bill payment recurring</option>
                        <option value="WEEKLY" key="WEEKLY">Weekly</option>
                        <option value="BIWEEKLY" key="BIWEEKLY">Biweekly</option>
                        <option value="MONTHLY" key="MONTHLY">Monthly</option>
                        <option value="ANNUALLY" key="ANNUALLY">Annually</option>
                    </FormField>
                    </Col></Row>

                    <Row><Col>&nbsp;</Col></Row>

                    <CancelButton label="Cancel" onClick={handleCancel} disabled={userBillsData.readOnly} />
                    &nbsp; &nbsp;
                    {userBillsData.bill.billStatus !== 'PAID' && <SubmitButton label='Pay' disabled={userBillsData.readOnly} />}
                    {userBillsData.bill.billStatus === 'PAID' && <span>No payment button appears because this bill was paid</span>}

                </FormContainer>}
        </>
    )
}

export default UserBillDetailPage